import React from 'react';


class Alert extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      this.props.onClose();
    }, 8000);
  }

  render() {
    const { children, onClose, type = 'warning' } = this.props;
    const getTypeClass = () => {
      switch (type) {
        case 'success':
          return 'alert-growl-success';
        case 'error':
          return 'alert-growl-error';
        case 'warning':
          return 'alert-growl-warning';
        default:
          return 'alert-growl-warning';
      }
    };

    return (
      <div className="alert-growl-container">
        <div className={`alert alert-growl alert-dismissable ${getTypeClass()}`}>
          <span className="alert-growl-close" onClick={onClose}>
            ×
          </span>
          {children}
        </div>
      </div>
    );
  }
}

export default Alert;
